module.exports = __webpack_public_path__ + "static/media/falcon-mode-dark.651bc4bd.jpg";